import { SearchOption } from '../../../../../types/common/table';
import { ReviewItemV2, ReviewListRequestOptionV2 } from '../../../../../types/review/list';
import ReviewApiV2 from '../../../../../lib/api/cs/review/ReviewApiV2';
import { WidgetReviewFilterOption } from '../../../../../types/widget';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const reviewListFetcher = async (option: SearchOption<WidgetReviewFilterOption>) => {
  const defaultResult = {
    totalCount: 0,
    reviews: [],
  };

  const result = checkValidId([option.id, option.brandId, option.productId])
    ? await ReviewApiV2.fetchReviewList(new ReviewListRequestOptionV2(option))
    : defaultResult;

  return {
    totalCount: result.totalCount,
    list: result.reviews.map((review) => new ReviewItemV2(review)),
  };
};
